// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ExportHistoryFields_EmployeeExportHistory_Fragment = { __typename?: 'EmployeeExportHistory' } & Pick<
  Types.EmployeeExportHistory,
  | 'id'
  | 'status'
  | 'totalRequestCount'
  | 'completedRequestCount'
  | 'resultUrl'
  | 'resultFileName'
  | 'failureReason'
  | 'createdAt'
  | 'updatedAt'
> &
  ExportHistoryFieldCreatedBy_EmployeeExportHistory_Fragment;

export type ExportHistoryFields_ExternalAccountExportHistory_Fragment = {
  __typename?: 'ExternalAccountExportHistory';
} & Pick<
  Types.ExternalAccountExportHistory,
  | 'id'
  | 'status'
  | 'totalRequestCount'
  | 'completedRequestCount'
  | 'resultUrl'
  | 'resultFileName'
  | 'failureReason'
  | 'createdAt'
  | 'updatedAt'
> &
  ExportHistoryFieldCreatedBy_ExternalAccountExportHistory_Fragment;

export type ExportHistoryFields_NumberOfEmployeeExportHistory_Fragment = {
  __typename?: 'NumberOfEmployeeExportHistory';
} & Pick<
  Types.NumberOfEmployeeExportHistory,
  | 'id'
  | 'status'
  | 'totalRequestCount'
  | 'completedRequestCount'
  | 'resultUrl'
  | 'resultFileName'
  | 'failureReason'
  | 'createdAt'
  | 'updatedAt'
> &
  ExportHistoryFieldCreatedBy_NumberOfEmployeeExportHistory_Fragment;

export type ExportHistoryFields_PerformanceReviewExportHistory_Fragment = {
  __typename?: 'PerformanceReviewExportHistory';
} & Pick<
  Types.PerformanceReviewExportHistory,
  | 'id'
  | 'status'
  | 'totalRequestCount'
  | 'completedRequestCount'
  | 'resultUrl'
  | 'resultFileName'
  | 'failureReason'
  | 'createdAt'
  | 'updatedAt'
> &
  ExportHistoryFieldCreatedBy_PerformanceReviewExportHistory_Fragment;

export type ExportHistoryFields_ProbationReviewExportHistory_Fragment = {
  __typename?: 'ProbationReviewExportHistory';
} & Pick<
  Types.ProbationReviewExportHistory,
  | 'id'
  | 'status'
  | 'totalRequestCount'
  | 'completedRequestCount'
  | 'resultUrl'
  | 'resultFileName'
  | 'failureReason'
  | 'createdAt'
  | 'updatedAt'
> &
  ExportHistoryFieldCreatedBy_ProbationReviewExportHistory_Fragment;

export type ExportHistoryFieldsFragment =
  | ExportHistoryFields_EmployeeExportHistory_Fragment
  | ExportHistoryFields_ExternalAccountExportHistory_Fragment
  | ExportHistoryFields_NumberOfEmployeeExportHistory_Fragment
  | ExportHistoryFields_PerformanceReviewExportHistory_Fragment
  | ExportHistoryFields_ProbationReviewExportHistory_Fragment;

export type ExportHistoryFieldCreatedBy_EmployeeExportHistory_Fragment = { __typename?: 'EmployeeExportHistory' } & {
  createdBy: Types.Maybe<
    { __typename?: 'Employee' } & {
      generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
        Types.EmployeeGeneralInformation,
        'preferredFullName'
      >;
    }
  >;
};

export type ExportHistoryFieldCreatedBy_ExternalAccountExportHistory_Fragment = {
  __typename?: 'ExternalAccountExportHistory';
} & {
  createdBy: Types.Maybe<
    { __typename?: 'Employee' } & {
      generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
        Types.EmployeeGeneralInformation,
        'preferredFullName'
      >;
    }
  >;
};

export type ExportHistoryFieldCreatedBy_NumberOfEmployeeExportHistory_Fragment = {
  __typename?: 'NumberOfEmployeeExportHistory';
} & {
  createdBy: Types.Maybe<
    { __typename?: 'Employee' } & {
      generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
        Types.EmployeeGeneralInformation,
        'preferredFullName'
      >;
    }
  >;
};

export type ExportHistoryFieldCreatedBy_PerformanceReviewExportHistory_Fragment = {
  __typename?: 'PerformanceReviewExportHistory';
} & {
  createdBy: Types.Maybe<
    { __typename?: 'Employee' } & {
      generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
        Types.EmployeeGeneralInformation,
        'preferredFullName'
      >;
    }
  >;
};

export type ExportHistoryFieldCreatedBy_ProbationReviewExportHistory_Fragment = {
  __typename?: 'ProbationReviewExportHistory';
} & {
  createdBy: Types.Maybe<
    { __typename?: 'Employee' } & {
      generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
        Types.EmployeeGeneralInformation,
        'preferredFullName'
      >;
    }
  >;
};

export type ExportHistoryFieldCreatedByFragment =
  | ExportHistoryFieldCreatedBy_EmployeeExportHistory_Fragment
  | ExportHistoryFieldCreatedBy_ExternalAccountExportHistory_Fragment
  | ExportHistoryFieldCreatedBy_NumberOfEmployeeExportHistory_Fragment
  | ExportHistoryFieldCreatedBy_PerformanceReviewExportHistory_Fragment
  | ExportHistoryFieldCreatedBy_ProbationReviewExportHistory_Fragment;

export type ExportHistoryListEmployeeQueryVariables = Types.Exact<{
  onlyMyTask: Types.Scalars['Boolean']['input'];
}>;

export type ExportHistoryListEmployeeQuery = { __typename?: 'Query' } & {
  exportHistoryList: Array<
    { __typename?: 'EmployeeExportHistory' } & Pick<Types.EmployeeExportHistory, 'format'> &
      ExportHistoryFields_EmployeeExportHistory_Fragment
  >;
};

export type ExportHistoryListNumberOfEmployeeQueryVariables = Types.Exact<{
  onlyMyTask: Types.Scalars['Boolean']['input'];
}>;

export type ExportHistoryListNumberOfEmployeeQuery = { __typename?: 'Query' } & {
  exportHistoryList: Array<
    { __typename?: 'NumberOfEmployeeExportHistory' } & ExportHistoryFields_NumberOfEmployeeExportHistory_Fragment
  >;
};

export type ExportHistoryListPerformanceReviewQueryVariables = Types.Exact<{
  onlyMyTask: Types.Scalars['Boolean']['input'];
  types: Array<Types.PerformanceReviewExportType> | Types.PerformanceReviewExportType;
}>;

export type ExportHistoryListPerformanceReviewQuery = { __typename?: 'Query' } & {
  exportHistoryList: Array<
    { __typename?: 'PerformanceReviewExportHistory' } & Pick<Types.PerformanceReviewExportHistory, 'exportType'> &
      ExportHistoryFields_PerformanceReviewExportHistory_Fragment
  >;
};

export type ExportHistoryListExternalAccountQueryVariables = Types.Exact<{
  onlyMyTask: Types.Scalars['Boolean']['input'];
}>;

export type ExportHistoryListExternalAccountQuery = { __typename?: 'Query' } & {
  exportHistoryList: Array<
    { __typename?: 'ExternalAccountExportHistory' } & ExportHistoryFields_ExternalAccountExportHistory_Fragment
  >;
};

export type ExportHistoryListProbationReviewQueryVariables = Types.Exact<{
  onlyMyTask: Types.Scalars['Boolean']['input'];
}>;

export type ExportHistoryListProbationReviewQuery = { __typename?: 'Query' } & {
  exportHistoryList: Array<
    { __typename?: 'ProbationReviewExportHistory' } & ExportHistoryFields_ProbationReviewExportHistory_Fragment
  >;
};

export const ExportHistoryFieldCreatedByFragmentDoc = /*#__PURE__*/ gql`
    fragment ExportHistoryFieldCreatedBy on ExportHistory {
  createdBy {
    generalInformation {
      preferredFullName
    }
  }
}
    `;
export const ExportHistoryFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment ExportHistoryFields on ExportHistory {
  id
  status
  totalRequestCount
  completedRequestCount
  resultUrl
  resultFileName
  failureReason
  createdAt
  updatedAt
  ...ExportHistoryFieldCreatedBy
}
    ${ExportHistoryFieldCreatedByFragmentDoc}`;
export const ExportHistoryListEmployeeDocument = /*#__PURE__*/ gql`
    query exportHistoryListEmployee($onlyMyTask: Boolean!) {
  exportHistoryList: exportHistoryListEmployee(onlyMyTask: $onlyMyTask) {
    ...ExportHistoryFields
    format
  }
}
    ${ExportHistoryFieldsFragmentDoc}`;

/**
 * __useExportHistoryListEmployeeQuery__
 *
 * To run a query within a React component, call `useExportHistoryListEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportHistoryListEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportHistoryListEmployeeQuery({
 *   variables: {
 *      onlyMyTask: // value for 'onlyMyTask'
 *   },
 * });
 */
export function useExportHistoryListEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<ExportHistoryListEmployeeQuery, ExportHistoryListEmployeeQueryVariables> &
    ({ variables: ExportHistoryListEmployeeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportHistoryListEmployeeQuery, ExportHistoryListEmployeeQueryVariables>(
    ExportHistoryListEmployeeDocument,
    options,
  );
}
export function useExportHistoryListEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExportHistoryListEmployeeQuery, ExportHistoryListEmployeeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportHistoryListEmployeeQuery, ExportHistoryListEmployeeQueryVariables>(
    ExportHistoryListEmployeeDocument,
    options,
  );
}
// @ts-expect-error
export function useExportHistoryListEmployeeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportHistoryListEmployeeQuery,
    ExportHistoryListEmployeeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExportHistoryListEmployeeQuery, ExportHistoryListEmployeeQueryVariables>;
export function useExportHistoryListEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExportHistoryListEmployeeQuery, ExportHistoryListEmployeeQueryVariables>,
): Apollo.UseSuspenseQueryResult<ExportHistoryListEmployeeQuery | undefined, ExportHistoryListEmployeeQueryVariables>;
export function useExportHistoryListEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExportHistoryListEmployeeQuery, ExportHistoryListEmployeeQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportHistoryListEmployeeQuery, ExportHistoryListEmployeeQueryVariables>(
    ExportHistoryListEmployeeDocument,
    options,
  );
}
export type ExportHistoryListEmployeeQueryHookResult = ReturnType<typeof useExportHistoryListEmployeeQuery>;
export type ExportHistoryListEmployeeLazyQueryHookResult = ReturnType<typeof useExportHistoryListEmployeeLazyQuery>;
export type ExportHistoryListEmployeeSuspenseQueryHookResult = ReturnType<
  typeof useExportHistoryListEmployeeSuspenseQuery
>;
export const ExportHistoryListNumberOfEmployeeDocument = /*#__PURE__*/ gql`
    query exportHistoryListNumberOfEmployee($onlyMyTask: Boolean!) {
  exportHistoryList: exportHistoryListNumberOfEmployee(onlyMyTask: $onlyMyTask) {
    ...ExportHistoryFields
  }
}
    ${ExportHistoryFieldsFragmentDoc}`;

/**
 * __useExportHistoryListNumberOfEmployeeQuery__
 *
 * To run a query within a React component, call `useExportHistoryListNumberOfEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportHistoryListNumberOfEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportHistoryListNumberOfEmployeeQuery({
 *   variables: {
 *      onlyMyTask: // value for 'onlyMyTask'
 *   },
 * });
 */
export function useExportHistoryListNumberOfEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportHistoryListNumberOfEmployeeQuery,
    ExportHistoryListNumberOfEmployeeQueryVariables
  > &
    ({ variables: ExportHistoryListNumberOfEmployeeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportHistoryListNumberOfEmployeeQuery, ExportHistoryListNumberOfEmployeeQueryVariables>(
    ExportHistoryListNumberOfEmployeeDocument,
    options,
  );
}
export function useExportHistoryListNumberOfEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportHistoryListNumberOfEmployeeQuery,
    ExportHistoryListNumberOfEmployeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportHistoryListNumberOfEmployeeQuery, ExportHistoryListNumberOfEmployeeQueryVariables>(
    ExportHistoryListNumberOfEmployeeDocument,
    options,
  );
}
// @ts-expect-error
export function useExportHistoryListNumberOfEmployeeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportHistoryListNumberOfEmployeeQuery,
    ExportHistoryListNumberOfEmployeeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExportHistoryListNumberOfEmployeeQuery,
  ExportHistoryListNumberOfEmployeeQueryVariables
>;
export function useExportHistoryListNumberOfEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportHistoryListNumberOfEmployeeQuery,
        ExportHistoryListNumberOfEmployeeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportHistoryListNumberOfEmployeeQuery | undefined,
  ExportHistoryListNumberOfEmployeeQueryVariables
>;
export function useExportHistoryListNumberOfEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportHistoryListNumberOfEmployeeQuery,
        ExportHistoryListNumberOfEmployeeQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExportHistoryListNumberOfEmployeeQuery,
    ExportHistoryListNumberOfEmployeeQueryVariables
  >(ExportHistoryListNumberOfEmployeeDocument, options);
}
export type ExportHistoryListNumberOfEmployeeQueryHookResult = ReturnType<
  typeof useExportHistoryListNumberOfEmployeeQuery
>;
export type ExportHistoryListNumberOfEmployeeLazyQueryHookResult = ReturnType<
  typeof useExportHistoryListNumberOfEmployeeLazyQuery
>;
export type ExportHistoryListNumberOfEmployeeSuspenseQueryHookResult = ReturnType<
  typeof useExportHistoryListNumberOfEmployeeSuspenseQuery
>;
export const ExportHistoryListPerformanceReviewDocument = /*#__PURE__*/ gql`
    query exportHistoryListPerformanceReview($onlyMyTask: Boolean!, $types: [PerformanceReviewExportType!]!) {
  exportHistoryList: exportHistoryListPerformanceReview(
    onlyMyTask: $onlyMyTask
    types: $types
  ) {
    ...ExportHistoryFields
    exportType
  }
}
    ${ExportHistoryFieldsFragmentDoc}`;

/**
 * __useExportHistoryListPerformanceReviewQuery__
 *
 * To run a query within a React component, call `useExportHistoryListPerformanceReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportHistoryListPerformanceReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportHistoryListPerformanceReviewQuery({
 *   variables: {
 *      onlyMyTask: // value for 'onlyMyTask'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useExportHistoryListPerformanceReviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportHistoryListPerformanceReviewQuery,
    ExportHistoryListPerformanceReviewQueryVariables
  > &
    ({ variables: ExportHistoryListPerformanceReviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportHistoryListPerformanceReviewQuery, ExportHistoryListPerformanceReviewQueryVariables>(
    ExportHistoryListPerformanceReviewDocument,
    options,
  );
}
export function useExportHistoryListPerformanceReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportHistoryListPerformanceReviewQuery,
    ExportHistoryListPerformanceReviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportHistoryListPerformanceReviewQuery, ExportHistoryListPerformanceReviewQueryVariables>(
    ExportHistoryListPerformanceReviewDocument,
    options,
  );
}
// @ts-expect-error
export function useExportHistoryListPerformanceReviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportHistoryListPerformanceReviewQuery,
    ExportHistoryListPerformanceReviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExportHistoryListPerformanceReviewQuery,
  ExportHistoryListPerformanceReviewQueryVariables
>;
export function useExportHistoryListPerformanceReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportHistoryListPerformanceReviewQuery,
        ExportHistoryListPerformanceReviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportHistoryListPerformanceReviewQuery | undefined,
  ExportHistoryListPerformanceReviewQueryVariables
>;
export function useExportHistoryListPerformanceReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportHistoryListPerformanceReviewQuery,
        ExportHistoryListPerformanceReviewQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExportHistoryListPerformanceReviewQuery,
    ExportHistoryListPerformanceReviewQueryVariables
  >(ExportHistoryListPerformanceReviewDocument, options);
}
export type ExportHistoryListPerformanceReviewQueryHookResult = ReturnType<
  typeof useExportHistoryListPerformanceReviewQuery
>;
export type ExportHistoryListPerformanceReviewLazyQueryHookResult = ReturnType<
  typeof useExportHistoryListPerformanceReviewLazyQuery
>;
export type ExportHistoryListPerformanceReviewSuspenseQueryHookResult = ReturnType<
  typeof useExportHistoryListPerformanceReviewSuspenseQuery
>;
export const ExportHistoryListExternalAccountDocument = /*#__PURE__*/ gql`
    query exportHistoryListExternalAccount($onlyMyTask: Boolean!) {
  exportHistoryList: exportHistoryListExternalAccount(onlyMyTask: $onlyMyTask) {
    ...ExportHistoryFields
  }
}
    ${ExportHistoryFieldsFragmentDoc}`;

/**
 * __useExportHistoryListExternalAccountQuery__
 *
 * To run a query within a React component, call `useExportHistoryListExternalAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportHistoryListExternalAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportHistoryListExternalAccountQuery({
 *   variables: {
 *      onlyMyTask: // value for 'onlyMyTask'
 *   },
 * });
 */
export function useExportHistoryListExternalAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportHistoryListExternalAccountQuery,
    ExportHistoryListExternalAccountQueryVariables
  > &
    ({ variables: ExportHistoryListExternalAccountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportHistoryListExternalAccountQuery, ExportHistoryListExternalAccountQueryVariables>(
    ExportHistoryListExternalAccountDocument,
    options,
  );
}
export function useExportHistoryListExternalAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportHistoryListExternalAccountQuery,
    ExportHistoryListExternalAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportHistoryListExternalAccountQuery, ExportHistoryListExternalAccountQueryVariables>(
    ExportHistoryListExternalAccountDocument,
    options,
  );
}
// @ts-expect-error
export function useExportHistoryListExternalAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportHistoryListExternalAccountQuery,
    ExportHistoryListExternalAccountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExportHistoryListExternalAccountQuery, ExportHistoryListExternalAccountQueryVariables>;
export function useExportHistoryListExternalAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportHistoryListExternalAccountQuery,
        ExportHistoryListExternalAccountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportHistoryListExternalAccountQuery | undefined,
  ExportHistoryListExternalAccountQueryVariables
>;
export function useExportHistoryListExternalAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportHistoryListExternalAccountQuery,
        ExportHistoryListExternalAccountQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportHistoryListExternalAccountQuery, ExportHistoryListExternalAccountQueryVariables>(
    ExportHistoryListExternalAccountDocument,
    options,
  );
}
export type ExportHistoryListExternalAccountQueryHookResult = ReturnType<
  typeof useExportHistoryListExternalAccountQuery
>;
export type ExportHistoryListExternalAccountLazyQueryHookResult = ReturnType<
  typeof useExportHistoryListExternalAccountLazyQuery
>;
export type ExportHistoryListExternalAccountSuspenseQueryHookResult = ReturnType<
  typeof useExportHistoryListExternalAccountSuspenseQuery
>;
export const ExportHistoryListProbationReviewDocument = /*#__PURE__*/ gql`
    query exportHistoryListProbationReview($onlyMyTask: Boolean!) {
  exportHistoryList: exportHistoryListProbationReview(onlyMyTask: $onlyMyTask) {
    ...ExportHistoryFields
  }
}
    ${ExportHistoryFieldsFragmentDoc}`;

/**
 * __useExportHistoryListProbationReviewQuery__
 *
 * To run a query within a React component, call `useExportHistoryListProbationReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportHistoryListProbationReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportHistoryListProbationReviewQuery({
 *   variables: {
 *      onlyMyTask: // value for 'onlyMyTask'
 *   },
 * });
 */
export function useExportHistoryListProbationReviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportHistoryListProbationReviewQuery,
    ExportHistoryListProbationReviewQueryVariables
  > &
    ({ variables: ExportHistoryListProbationReviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportHistoryListProbationReviewQuery, ExportHistoryListProbationReviewQueryVariables>(
    ExportHistoryListProbationReviewDocument,
    options,
  );
}
export function useExportHistoryListProbationReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportHistoryListProbationReviewQuery,
    ExportHistoryListProbationReviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportHistoryListProbationReviewQuery, ExportHistoryListProbationReviewQueryVariables>(
    ExportHistoryListProbationReviewDocument,
    options,
  );
}
// @ts-expect-error
export function useExportHistoryListProbationReviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportHistoryListProbationReviewQuery,
    ExportHistoryListProbationReviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExportHistoryListProbationReviewQuery, ExportHistoryListProbationReviewQueryVariables>;
export function useExportHistoryListProbationReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportHistoryListProbationReviewQuery,
        ExportHistoryListProbationReviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportHistoryListProbationReviewQuery | undefined,
  ExportHistoryListProbationReviewQueryVariables
>;
export function useExportHistoryListProbationReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportHistoryListProbationReviewQuery,
        ExportHistoryListProbationReviewQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportHistoryListProbationReviewQuery, ExportHistoryListProbationReviewQueryVariables>(
    ExportHistoryListProbationReviewDocument,
    options,
  );
}
export type ExportHistoryListProbationReviewQueryHookResult = ReturnType<
  typeof useExportHistoryListProbationReviewQuery
>;
export type ExportHistoryListProbationReviewLazyQueryHookResult = ReturnType<
  typeof useExportHistoryListProbationReviewLazyQuery
>;
export type ExportHistoryListProbationReviewSuspenseQueryHookResult = ReturnType<
  typeof useExportHistoryListProbationReviewSuspenseQuery
>;
